import React from "react";
import { useLanguage } from "../hooks/useLanguage";
import { Globe } from "lucide-react";

export function LanguageToggle({ variant = "default" }) {
  const { language, setLanguage } = useLanguage();

  const toggleLanguage = () => {
    setLanguage(language === "en" ? "es" : "en");
  };

  if (variant === "compact") {
    return (
      <button
        onClick={toggleLanguage}
        className="flex items-center gap-1.5 text-white/70 hover:text-white hover:bg-white/10 px-3 py-2 rounded-lg transition-all text-sm font-semibold"
        data-testid="language-toggle"
        title={language === "en" ? "Cambiar a Español" : "Switch to English"}
      >
        <Globe size={16} />
        <span className="uppercase">{language}</span>
      </button>
    );
  }

  if (variant === "landing") {
    return (
      <button
        onClick={toggleLanguage}
        className="flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white px-4 py-2 rounded-xl transition-all font-bold text-sm"
        data-testid="language-toggle"
      >
        <Globe size={18} />
        <span>{language === "en" ? "Español" : "English"}</span>
      </button>
    );
  }

  // Default variant - dropdown style
  return (
    <div className="relative">
      <button
        onClick={toggleLanguage}
        className="flex items-center gap-2 bg-gray-100 hover:bg-gray-200 text-gray-700 px-4 py-2 rounded-xl transition-all font-bold text-sm"
        data-testid="language-toggle"
      >
        <Globe size={18} />
        <span>{language === "en" ? "English" : "Español"}</span>
        <span className="text-xs text-gray-500">
          → {language === "en" ? "ES" : "EN"}
        </span>
      </button>
    </div>
  );
}

export default LanguageToggle;
